export let est1_steps = [
    {
        id: 'idiomas',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP1.WIZBT',
        videoBanner: 'idiomas',
        icon : 'language',
        ruta : './languages',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP1.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP1.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'reactivos',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP1-1.WIZBT',
        videoBanner: 'reactivos',
        icon : 'sentiment_satisfied_alt',
        ruta : './reactives',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP1-1.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP1-1.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'forall',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP2.WIZBT',
        videoBanner: 'forall',
        icon : 'format_list_numbered',
        ruta : './ForAll',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP2.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP2.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'demo',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP3.WIZBT',
        videoBanner: 'demograficos',
        icon : 'poll',
        ruta : './demographics',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP3.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP3.SUBTI',
        status : 1,
        visible: true
    },
    {
        id: 'abiertas',
        title  : 'WIZARD.CERTIFICAR.STEPS.STP3-1.WIZBT',
        videoBanner: 'abiertas',
        icon : 'help_outline',
        ruta : './open',
        tituloPagina: 'WIZARD.CERTIFICAR.STEPS.STP3-1.TITULO',
        subtiPagina: 'WIZARD.CERTIFICAR.STEPS.STP3-1.SUBTI',
        status : 1,
        visible: true
    }
];
